export default __webpack_public_path__ + "6447aa175fb93a36f54eff0285691bf1.png";